import React from "react";
import { useTranslation } from "react-i18next";

import { ArrowRight } from "@airhelp/icons";
import { Flex, VStack, Button, Text, Image } from "@chakra-ui/react";

import ahBrandingSign from "assets/images/branding-sign.svg";
import { useLocale } from "contexts/LocaleContext/LocaleContextProvider";
import { airhelpUtils } from "utils";
import { useTrackEvent } from "utils/tracking/hooks";

const UpsellBanner = () => {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const { trackUpsellOption } = useTrackEvent();

  return (
    <Flex
      alignItems="flex-start"
      justifyContent={{ base: "space-between", md: "unset", xlg: "space-between" }}
      bgColor="primary.200"
      borderRadius="lg"
      p={5}
      position="relative"
      overflow="hidden"
      height="auto"
      flex="1"
      flexDirection={{ base: "column", md: "row", xlg: "column" }}
      gap={5}
    >
      <Image src={ahBrandingSign} h={6} />
      <VStack alignItems="flex-start" spacing={0} alignSelf="flex-start">
        <Text fontSize="lg" fontWeight="bold">
          Love lounge access?
        </Text>
        <Text fontSize="md" color="greyscale.600">
          Get even more when you upgrade to AirHelp Plus Pro.
        </Text>
      </VStack>
      <Button
        as="a"
        size="md"
        variant={{ base: "primary", md: "subtle", xlg: "primary" }}
        marginLeft={{ base: "unset", md: "auto", xlg: "unset !important" }}
        alignSelf={{ base: "unset", md: "center", xlg: "flex-start !important" }}
        href={airhelpUtils.websiteAhPlusLandingPage("pricing-plans", locale)}
        zIndex="10"
        onClick={() => trackUpsellOption("get membership pro", "lounges page - banner button")}
      >
        {t("common.upgrade")} <ArrowRight ml={1} boxSize={4} />
      </Button>
      <Image
        src={ahBrandingSign}
        position="absolute"
        h={{ base: "125px", md: "280px", xlg: "200px" }}
        right={{ base: "-30px", md: "-80px", xlg: "-60px" }}
        bottom={{ base: "-40px", md: "-160px", xlg: "-85px" }}
      />
    </Flex>
  );
};

export default UpsellBanner;
